export default "__VITE_ASSET__CnAGP97C__"